import BigNumber from 'bignumber.js';

import { AnalyticsApi, mainApi, queryFnNotifyWrapper } from 'modules/api';
import { captureError } from 'modules/api/captureError';
import { RangeSelectorType } from 'modules/api/const';
import { t } from 'modules/i18n';
import { stakeCacheTags } from 'modules/stake/stakeCacheTags';

export type IStakingChartData = {
  tvl: BigNumber;
  timestamp: number;
}[];

export const EMPTY_STAKING_CHART_DATA: IStakingChartData = [];

export const { useGetStakingChartDataQuery } = mainApi.injectEndpoints({
  endpoints: build => ({
    getStakingChartData: build.query<IStakingChartData, RangeSelectorType>({
      queryFn: queryFnNotifyWrapper<RangeSelectorType, void, IStakingChartData>(
        async period => {
          const api = AnalyticsApi.getInstance();

          const data = await api.getStakingChartData(period);

          return {
            data: data.map(item => ({
              tvl: new BigNumber(item.tvl),
              timestamp: item.timestamp,
            })),
          };
        },
        error => {
          const message = t('notification.failedStakingChartData');
          captureError(error, message);

          return message;
        },
      ),
      providesTags: [stakeCacheTags.getBalances],
    }),
  }),
});
